export function getValueOrDefault<T>(value: T | undefined | null, defaultValue: T) {
  return value || defaultValue;
}
